export interface DiagnosticScores {
  vision: number;
  execution: number;
  sustainment: number;
}

export interface DiagnosticOption {
  text: string;
  scores: DiagnosticScores;
}

export interface DiagnosticQuestion {
  id: number;
  question: string;
  options: DiagnosticOption[];
}

export const diagnosticQuestions: DiagnosticQuestion[] = [
  {
    id: 1,
    question:
      "When it comes to where your business is headed, how aligned is your leadership team?",
    options: [
      {
        text: "We have a clear vision and everyone is moving in the same direction.",
        scores: { vision: 0, execution: 0, sustainment: 0 }
      },
      {
        text: "We've talked about it, but we haven't locked it in.",
        scores: { vision: 3, execution: 1, sustainment: 1 }
      },
      {
        text: "Different leaders have different ideas about the direction.",
        scores: { vision: 5, execution: 2, sustainment: 2 }
      },
      {
        text: "We're operating without a defined direction.",
        scores: { vision: 7, execution: 1, sustainment: 1 }
      }
    ]
  },
  {
    id: 2,
    question:
      "When you launch a new initiative — a system, a process change, a strategic priority — what usually happens?",
    options: [
      {
        text: "It gets done. On time, with the results we expected.",
        scores: { vision: 0, execution: 0, sustainment: 0 }
      },
      {
        text: "We start strong, then it stalls or gets pushed aside.",
        scores: { vision: 1, execution: 5, sustainment: 2 }
      },
      {
        text: "We launch it, but people don't really adopt it.",
        scores: { vision: 1, execution: 2, sustainment: 5 }
      },
      {
        text: "We struggle to get it off the ground in the first place.",
        scores: { vision: 2, execution: 7, sustainment: 1 }
      }
    ]
  },
  {
    id: 3,
    question:
      "How does your organization allocate budget, people, and technology to your biggest priorities?",
    options: [
      {
        text: "Resources follow our top priorities consistently.",
        scores: { vision: 0, execution: 0, sustainment: 0 }
      },
      {
        text: "We allocate resources, but urgent problems keep pulling them away.",
        scores: { vision: 1, execution: 4, sustainment: 2 }
      },
      {
        text: "We're spread too thin — too many priorities, not enough focus.",
        scores: { vision: 3, execution: 3, sustainment: 3 }
      },
      {
        text: "We never seem to have enough to do what we're trying to do.",
        scores: { vision: 4, execution: 4, sustainment: 4 }
      }
    ]
  },
  {
    id: 4,
    question:
      "After you implement a change — new software, new process, new structure — what happens six months later?",
    options: [
      {
        text: "It sticks. Teams have adopted it and it's now how we work.",
        scores: { vision: 0, execution: 0, sustainment: 0 }
      },
      {
        text: "It worked at first, but teams have drifted back to old habits.",
        scores: { vision: 1, execution: 2, sustainment: 6 }
      },
      {
        text: "Some teams adopted it, others didn't.",
        scores: { vision: 2, execution: 2, sustainment: 5 }
      },
      {
        text: "We almost always revert to how things were before.",
        scores: { vision: 2, execution: 3, sustainment: 7 }
      }
    ]
  },
  {
    id: 5,
    question:
      "How does your organization measure whether transformation efforts are working?",
    options: [
      {
        text: "We have clear metrics and we adjust based on what they tell us.",
        scores: { vision: 0, execution: 0, sustainment: 0 }
      },
      {
        text: "We track metrics but rarely use them to make decisions.",
        scores: { vision: 1, execution: 3, sustainment: 4 }
      },
      {
        text: "Measurement is inconsistent — it depends on who's running the initiative.",
        scores: { vision: 2, execution: 4, sustainment: 3 }
      },
      {
        text: "We don't have a reliable way to measure transformation outcomes.",
        scores: { vision: 5, execution: 3, sustainment: 2 }
      }
    ]
  }
];
